

import FrontFacebookIcon from '../../Icons/FrontFacebookIcon';
import FrontYoutubeIcon from '../../Icons/FrontYoutubeIcon';
import QuestionBlackIcon from "../../Icons/QuestionBlackIcon";
import QuestionSub1 from "../../Icons/QuestionSub1";
import QuestionSub2 from "../../Icons/QuestionSub2";
import MultiChoiceIcon from "../../Icons/MultiChoiceIcon";
import ExternalIcon from "../../Icons/ExternalIcon";
import TwitterIcon from "../../Icons/TwitterIcon";
import ShareIcon from "../../Icons/ShareIcon";
import BonusIcon from "../../Icons/BonusIcon";
import CustomIcon from "../../Icons/CustomIcon";
import FrontInstagramIcon from "../../Icons/FrontInstagramIcon";


const EntryIcon = ({ entry, color }) => {


  function loadIcon(entry) {
    const icons = {
      facebook: <FrontFacebookIcon width={20} height={20} />,
      ytwatchvideo: <FrontYoutubeIcon width={20} height={20} />,
      ytsubmitvideo: <FrontYoutubeIcon width={20} height={20} />,
      ytsubscribe: <FrontYoutubeIcon width={20} height={20} />,
      tweet: <TwitterIcon width={20} height={20} />,
      tweethashtag: <TwitterIcon width={20} height={20} />,
      answerquestion: <QuestionBlackIcon width={20} height={20} />,
      chooseimage: <QuestionSub1 width={20} height={20} />,
      singlechoice: <QuestionSub2 width={20} height={20} />,
      multiplechoice: <MultiChoiceIcon width={20} height={20} />,
      externalpage: <ExternalIcon width={20} height={20} />,
      viralshare: <ShareIcon width={20} height={20} />,
      bonus: <BonusIcon width={20} height={20} />,
      customentry: <CustomIcon width={20} height={20} />,
      instagram: <FrontInstagramIcon  />,
      shfacebook: <FrontFacebookIcon width={20} height={20} />,
      shx: <TwitterIcon width={20} height={20} />,
      shwhatsapp: <BonusIcon width={20} height={20} />,
    };

    return icons[entry.type] || null;
  }

  return (

    <>
      {loadIcon(entry)}

    </>

  );
};

export default EntryIcon;
